import React, { Component } from 'react'
import Icon from '../../../../src/components/Icon'
import iconsList from '../../../../src/icons/icon-list'
import styles from './style.css'

function mapObject (object, callback) {
  return Object.keys(object).map((key) => {
    return callback(key, object[key])
  })
}

export default class Icons extends Component {
  constructor (props) {
    super(props)
    this.state = {
      size: 's'
    }
  }
  renderIcons () {
    return mapObject(iconsList, (key, value) => {
      return (
        <div key={key} className={styles.icon}>
          <div className={styles.display}>
            <Icon name={key} />
          </div>
          <div className={styles.name}>
            {key}
          </div>
        </div>
      )
    })
  }
  render () {
    return (
      <div className={styles.wrapper}>
        <h2>Icons</h2>
        <div className={styles.icons}>
          {this.renderIcons()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Icons/index.js